import { observable } from "mobx";
import RefundCounterpartyOverridability from "./refundCounterpartyOverridability";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargePartialRefundationActionResponse {
  /**
   * Indicates if action on charge is allowed.
   */
  @observable
  isAllowed!: boolean;

  @observable
  counterpartyOverridability!: RefundCounterpartyOverridability;

  /**
   * Available fuel type IDs, fuel type can be changed to.
   */
  @observable
  availableFuelTypeIds?: string[];
}
